import { render, staticRenderFns } from "./VaccineHistory.vue?vue&type=template&id=f4dbf584&scoped=true&"
import script from "./VaccineHistory.vue?vue&type=script&lang=js&"
export * from "./VaccineHistory.vue?vue&type=script&lang=js&"
import style0 from "./VaccineHistory.scss?vue&type=style&index=0&id=f4dbf584&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4dbf584",
  null
  
)

export default component.exports